import { BOTTLE_BOX_TYPES, BOX_COLORS, PUNCHED_BOX_TYPES } from '../utils/products.enums'
import { PRODUCTS_LIST } from '../utils/products.list'
import { BottleSize } from '../utils/BottleSize'
import { PrintingSettings } from '../utils/PrintingSettings'

export default class BottleBoxFormModel {
  name = PRODUCTS_LIST.BOTTLE_BOX;

  constructor () {
    this.type = BOTTLE_BOX_TYPES.BRIEF_CASE
    this.bottlesAmount = null
    this.bottleSize = new BottleSize()
    this.color = BOX_COLORS.HAVANA
    this.boxType = PUNCHED_BOX_TYPES.MICRO_WAVE
    this.printing = new PrintingSettings()
    this.amount = null
    this.additionalNotes = null
    this.email = null
  }
}
